import React, { useContext, useEffect } from 'react';
import { ClipLoader } from 'react-spinners';
import About from './About';
import Banner from './Banner';
import Blog from './Blog';
import JoinOurTeam from './JoinOurTeam';
import OurPartner from './OurPartners';
import Portfolio from './Portfolio';
import { getHomeDetails, getSaluteDetails } from '../Redux/API';
import { AppContext } from '../Redux/ContextProvider';
import Testimonial from './Testimonial';
import NextEvent from '../NextEvent/index';
import Partner from '../OurPartners/Partner';
import Activities from '../About/Activities';
import AllEvents from '../Conference/AllEvents';
import OurPartners from '../OurPartners';
import Blogs from '../Blogs';

const Home = () => {
    const { appState, dispatch } = useContext(AppContext);
    const { common, home, homeLoader, salute, saluteLoader } = appState;

    useEffect(() => {
        getHomeDetails(appState, dispatch)
        getSaluteDetails(appState, dispatch)
    }, [])

    return (
        <>
            {
                homeLoader ?
                    <div className='home-spinner'>
                        <ClipLoader color={"#2A5350"} loading={true} size={60} />
                    </div>
                    :
                    Object.keys(home).length &&
                    <>
                        <Banner
                            banner={home.banner_section}
                            social={common.common_section}
                        />
                        <About about={home.about_section} />
                        <NextEvent lastconference={home.last_conference_section} />
                        <Portfolio portfolio={home.portfolio_section} />
                        {/* <Blog blog={home.blogs_section} /> */}
                        {/* <JoinOurTeam /> */}
                        {/* <AllEvents /> */}
                        <Blogs />
                        <OurPartners />
                        {/* <OurPartner partner={home.partners_section} /> */}
                        <Testimonial testimonial={home.testimonial_section} />
                    </>
            }
        </>
    )
}

export default Home